export const emptyChart = {
	title: "New Chart",
	isGrouped: true,
	players: [],
	widgets: [],
	isArchived: false,
};
